export const getRandom = (nunmber: number = 50) =>
  Math.floor(Math.random() * nunmber);

export const getDaysAgo = (daysAgo: number) => {
  const date = new Date();
  date.setDate(date.getDate() - daysAgo);
  return getDatePortion(date);
};

function isValidDate(date: string) {
  const parsedDate = new Date(date);
  return parsedDate instanceof Date && !isNaN(parsedDate.getTime());
}

export function getDatePortionFromDateString(datestring: string) {
  const parsedDate =
    datestring === 'now'
      ? new Date()
      : isValidDate(datestring)
        ? new Date(datestring)
        : null;

  return parsedDate?.toISOString()?.split('T')?.[0] || ''; // Keeps only the date portion
}

export function getDatePortion(date: Date) {
  return date?.toISOString()?.split('T')?.[0] || ''; // Keeps only the date portion
}

export const getLastNDays = (period: number) => {
  const dates = [];
  for (let i = 0; i < period; i++) {
    const date = new Date();
    date.setDate(date.getDate() - i);
    dates.push(date); // Converts to RFC 3339 format
  }
  return dates.reverse();
};

export interface EventOverview {
  DC: string;
  DH: string;
  DI: string;
  DL: string;
  DM: string;
  IC: string;
  IH: string;
  II: string;
  IL: string;
  IM: string;
  OC: string;
  OH: string;
  OI: string;
  OL: string;
  OM: string;
  RC: string;
  RH: string;
  RI: string;
  RL: string;
  RM: string;
  TC: string;
  TH: string;
  TI: string;
  TL: string;
  TM: string;
}
